<template>
  <div class="main-wrapper --main-layout">
    <div class="main-row">
      <div class="main-container">
        <AsideMenu />
        <main class="main-slot">
          <slot />
        </main>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AsideMenu from "@/components/aside/AsideMenu.vue";
</script>

<style lang="scss" scoped>
@import "@/assets/style/main";

.main {
  &-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    padding-right: 20px;
    @media (max-width: 960px) {
      padding-right: 0;
    }
  }

  &-row {
    display: flex;
    flex-flow: row wrap;
    flex: 1;
    width: 100%;
  }

  &-container {
    display: flex;
    flex: 1;
    flex-flow: row;
    position: relative;
    gap: 109px;
    width: 100%;
    align-items: flex-start;
    @media (max-width: 1100px) {
      gap: 30px;
    }
    @media (max-width: 960px) {
      gap: 0px;
      flex-direction: column;
    }
  }

  &-slot {
    display: flex;
    flex: 1;
    align-items: flex-start;
    position: relative;
    z-index: 3;
    width: 100%;
    height: 100%;
  }
}
</style>
